import React, { useState } from 'react'
import { Image, View } from 'react-native'
import styled from 'styled-components/native'

import I18n from 'APP/I18n'
import { usePushNotificationPermission } from 'APP/Hooks/usePushNotificationPermission'
import useImageDimensions from 'APP/Hooks/useImageDimensions'

import Typography from 'APP/Converse/Typography'
import Button from 'APP/Converse/Button'
import { Images } from 'APP/Themes'

const Container = styled(View)`
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

const NotificationsImage = styled(Image)`
  resize-mode: contain;
`

const Title = styled(Typography)`
  text-align: center;
`

const Subheader = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  text-align: center;
`

const CTA_TITLE_KEYS = {
  enable: 'PushNotificationPermissionModalScreen.primaryButton',
  openSettings: 'PushNotificationPermissionModalScreen.openSettingsButton',
}

const PushNotificationPermissionModalScreen = ({ navigation }) => {
  const { canPromptForPermission, requestPermissionOrOpenSettings } = usePushNotificationPermission(
    { source: 'PushNotificationPermissionModalScreen' }
  )
  const { aspectRatio, isLoading: isImageLoading } = useImageDimensions(Images.notificationsExample)
  const [containerWidth, setContainerWidth] = useState(0)

  const onDismiss = () => navigation.goBack()
  const onAllow = async () => {
    await requestPermissionOrOpenSettings()
    navigation.goBack()
  }

  const primaryTitle = I18n.t(
    canPromptForPermission ? CTA_TITLE_KEYS.enable : CTA_TITLE_KEYS.openSettings
  )

  return (
    <Container onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}>
      {!isImageLoading && containerWidth > 0 && aspectRatio > 0 && (
        <NotificationsImage
          source={Images.notificationsExample}
          style={{ width: containerWidth, height: containerWidth / aspectRatio }}
        />
      )}
      <Title variant="h1">{I18n.t('PushNotificationPermissionModalScreen.title')}</Title>
      <Subheader variant="subheader">
        {I18n.t('PushNotificationPermissionModalScreen.subheader')}
      </Subheader>

      <Button
        variant="primary"
        widthVariant="full"
        title={primaryTitle}
        onPress={onAllow}
        testID={'allow-button'}
        analyticsName="allow-button"
      />
      <Button
        variant="tertiary"
        widthVariant="full"
        title={I18n.t('PushNotificationPermissionModalScreen.secondaryButton')}
        onPress={onDismiss}
        testID={'dismiss-button'}
        analyticsName="dismiss-button"
      />
    </Container>
  )
}

export default PushNotificationPermissionModalScreen
